<template>
  <div>
    <div class="page-header">
      <h2>Order summary</h2>
    </div>

    <table class="w3-table-all">
      <tr>
        <!-- <th></th> -->
        <th>Product</th>
        <th>Details</th>
        <th>Price/unit</th>
        <th>Quantity</th>
        <th>Price</th>
      </tr>
      <tr v-for="item in currentBasket" v-bind:key="item">
        <!-- <td>
                    <button>Edit</button>
                </td> -->
        <td>{{ item.name }}</td>
        <td>
          <template v-for="(value, input) in item.user_inputs" :key="input">
            <li v-if="value !== ''">{{ input }} : {{ value }}</li>
          </template>
        </td>
        <td>{{ allParts[item.key].unit_prices[0].chf }}</td>
        <td>{{ item.quantity }}</td>
        <td>{{ item.price }}</td>
      </tr>
    </table>

    <div class="page-header">
      <h2>Order details</h2>
    </div>

    <!-- {{orderDetails.order_userinputs}} -->
    <p style="color: blue;"> <b>If this order has already been paid, please indicate the TID number. <br> Otherwise specify the budget code. <br> The information will be reviewed before the order is accepted. </b></p>

    <div v-for="input in orderDetails.order_userinputs.slice().reverse()" v-bind:key="input">
      <div v-if="input.type == 'text'">
        <label :for="input.name" class="tooltip">
          <span class="tooltiptext">{{ input.desc }}</span>
          {{ input.name }}
        </label>
        <input
          class="w3-input w3-border w3-round"
          type="text"
          :id="input.name"
          :name="input.name"
        />
      </div>
      <div v-else-if="input.type == 'comment'">
        <label :for="input.name" class="tooltip">
          <span class="tooltiptext">{{ input.desc }}</span>
          {{ input.name }}
        </label>
      </div>
      <div v-else-if="input.type == 'list'">
        <label :for="input.name" class="tooltip">
          <span class="tooltiptext">{{ input.desc }}</span>
          {{ input.name }}
        </label>
        <select
          class="w3-select w3-border w3-round"
          :name="input.name"
          :id="input.name"
        >
          <option disabled selected>Select an option</option>
          <option
            v-for="option in input.options"
            v-bind:key="option"
            v-bind:value="option.value"
          >
            {{ option.text }}
          </option>
        </select>
      </div>
      <div v-else-if="input.type == 'boolean'">
        <label class="tooltip">
          <span class="tooltiptext">{{ input.desc }}</span>
          {{ input.name }}
        <input
          class="w3-check w3-border w3-round"
          type="checkbox"
          :id="input.name"
          :name="input.name"
          :value="input.value"
        />
        </label>
      </div>
    </div>
    
    <br>

    <template v-if="!reqshipment">
      <br />
      <label> Shipping needed 
      <input
        type="checkbox"
        id="shipment_checkbox"
        class="w3-check w3-rounded w3-border"
        onclick="this.checked ? document.getElementById('shipment_details').style.display='block': document.getElementById('shipment_details').style.display='none'"
      /></label>
    </template>

    <div id="shipment_details">
      <!-- Check for multiple shippings -->
      <!-- <label>
      <input
        type="checkbox"
        id="multiple_shippings"
        class="w3-check w3-rounded w3-border"
        @change="multipleShipping()"
      /> Multiple shipments </label> -->
    <!-- <div class="w3-panel"> -->
      <p>If you need separate shippings, please make separate orders.</p>
    <!-- </div> -->

      <div class="page-header">
        <h2>Shipment details</h2>
      </div>

      <div v-for="input in orderDetails.shipment_userinputs" v-bind:key="input">
        <div v-if="input.type == 'text'">
          <label :for="input.name" class="tooltip">
            <span class="tooltiptext">{{ input.desc }}</span>
            {{ input.name }}
          </label>
          <input
            class="w3-input w3-border w3-round"
            type="text"
            :id="input.name"
            :name="input.name"
          />
        </div>
        <div v-else-if="input.type == 'comment'">
          <label :for="input.name" class="tooltip">
            <span class="tooltiptext">{{ input.desc }}</span>
            {{ input.name }}
          </label>
        </div>
        <div v-else-if="input.type == 'list'">
          <label :for="input.name" class="tooltip">
            <span class="tooltiptext">{{ input.desc }}</span>
            {{ input.name }}
          </label>
          <select
            class="w3-select w3-border w3-round"
            :name="input.name"
            :id="input.name"
          >
            <option disabled selected>Select an option</option>
            <option
              v-for="option in input.options"
              v-bind:key="option"
              v-bind:value="option.value"
            >
              {{ option.text }}
            </option>
          </select>
        </div>
        <div v-else-if="input.type == 'boolean'">
          <label class="tooltip">
            <span class="tooltiptext">{{ input.desc }}</span>
            {{ input.name }}
          </label>
          <input
            class="w3-check w3-border w3-round"
            type="checkbox"
            :id="input.name"
            :name="input.name"
            :value="input.value"
          />
        </div>
      </div>
    </div>
  </div>

  <br />
  <button id="send_order" @click="sendOrder">Send order</button>
  <div id="order_failed" class="w3-panel w3-red" style="display: none">
    <h3>Failed to send order</h3>
    <p style="white-space: pre-line">{{ order_error }}</p>
  </div>
  <div id="order_success" class="w3-panel w3-green" style="display: none">
    <h3>Success</h3>
    <p>Your order has been registered correctly.</p>
  </div>
</template>

<style scoped>
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

tr:nth-child(even) {
  background-color: #dddddd;
}
</style>

<script>
// import { request } from 'express';
export default {
    name: 'OrderDetails',
    props: 
    {
        display: Boolean,
    },
    computed: {
        currentBasket() {
            return this.$store.getters.getBasket;
        },
        allParts() {
            return this.$store.getters.getParts;
        },
        allPackages() {
            return this.$store.getters.getPackages;
        },
        totalPrice() {
            var price = 0;
            this.currentBasket.forEach(item => {
                price += item.price;
            });
            return price;
        },
        orderDetails() {
            return this.$store.getters.getOrderConfig;
        },
        userDetails() {
            return this.$store.getters.getUserDetails;
        },
        reqshipment() {
            var part_index;
            var reqshipment = false;
            for(part_index = 0; part_index < this.currentBasket.length; part_index++) {
                var part = this.currentBasket[part_index];
                reqshipment = reqshipment | part.reqshipment;
            }      
            return reqshipment;
        }
    },
    data() {
        return {
            order_error : "",
        }
    },
    methods: {
        sendOrder: function () {

            var userDetails = null;
            var user_inputs = {}
            var user_inputs_shippings = {}
            var parts = []
            var packages = []

            console.log("UserDetails from store", userDetails)

            fetch(process.env.VUE_APP_URL+'/restapi/user', {
                    method: 'GET',
                    credentials: 'include',
                    headers: {'Content-Type': 'application/json'}
                })
                .then( (response) => {
                    return response.json();
                })
                .then( (json) => {
                    userDetails = json['user'];

                    var payload = {
                        'email' : userDetails['email'],
                        'details' : {},
                        // 'shipping' : {},
                        'basket' : {
                            'parts' : [],
                            'packages' : []
                        } 
                    }
                    if( this.orderDetails.order_userinputs != [] ) {
                        this.orderDetails.order_userinputs.forEach(input => {
                        var input = document.getElementById(input.name);
                        if(input.type == 'checkbox') {
                            user_inputs[input.name] = input.checked;
                        }
                        else if(input.type == "list" ) {
                            console.log(document.getElementById(input.name).value);
                        }
                        else {
                            user_inputs[input.name] = document.getElementById(input.name).value;
                        }
                        });
                    }

                    payload['details'] = user_inputs

                    if( this.orderDetails.shipment_userinputs != [])
                    {   
                        if(!this.reqshipment) {
                            if( document.getElementById('shipment_checkbox').checked ){
                                this.orderDetails.shipment_userinputs.forEach(input => {
                                    var input = document.getElementById(input.name);
                                    if(input.type == 'checkbox') {
                                        user_inputs_shippings[input.name] = input.checked;
                                    }
                                    else if(input.type == "list" ) {
                                        console.log(document.getElementById(input.name).value);
                                    }
                                    else {
                                        user_inputs_shippings[input.name] = document.getElementById(input.name).value;
                                    }
                                });
                                payload['shipping'] = {}
                                payload['shipping'] = user_inputs_shippings  
                            }
                        }
                        else {
                            this.orderDetails.shipment_userinputs.forEach(input => {
                                var input = document.getElementById(input.name);
                                if(input.type == 'checkbox') {
                                    user_inputs_shippings[input.name] = input.checked;
                                }
                                else if(input.type == "list" ) {
                                    console.log(document.getElementById(input.name).value);
                                }
                                else {
                                    user_inputs_shippings[input.name] = document.getElementById(input.name).value;
                                }
                            });
                            payload['shipping'] = {}
                            payload['shipping'] = user_inputs_shippings
                        }
                    }



                    this.currentBasket.forEach(
                        (item) => {
                            parts.push( {
                                "part_id" : item.part_id,
                                "quantity" : item.quantity,
                                "user_inputs" : item.user_inputs
                            } )
                        }
                    )
                    payload['basket']['parts'] = parts

                    console.log(payload);

                    if (parts.length == 0 && packages.length == 0) {
                        this.order_error = "The basket is empty: nothing to order!";
                        document.getElementById("order_failed").style.display = "block";
                    }
                    else {
                        fetch( process.env.VUE_APP_URL + "/restapi/order", {
                            method: "POST", 
                            headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(payload)
                            }).then(res => {
                                // console.log(res)
                                res.json().then(
                                    (response) => {
                                        console.log("Request complete! response:", response);
                                        if (response.status == 0) {
                                            document.getElementById("order_failed").style.display = "none";
                                            document.getElementById("order_success").style.display = "block";
                                            document.getElementById("send_order").disabled = true;
                                            this.$store.dispatch("emptyBasket");
                                        }
                                        else {
                                            this.order_error = response.errors.join(' \n');
                                            document.getElementById("order_success").style.display = "none";
                                            document.getElementById("order_failed").style.display = "block";
                                            document.getElementById("send_order").disabled = false;
                                        }
                                    }
                                );
                        });
                    }                

                });

        },

        multipleShipping: function() {
          var toggle = document.getElementById("multiple_shippings").checked

          document.getElementById("send_order").disabled = toggle;
          if (toggle)
            document.getElementById('shipping_warning').style.display='block';          
          else
            document.getElementById('shipping_warning').style.display='none';
        }
    },
    mounted() {
        if (this.reqshipment)
            document.getElementById('shipment_details').style.display = 'block';
        else
            document.getElementById('shipment_details').style.display = 'none';      
    }
}
</script>

<style scoped>
.tooltip {
  position: relative;
  display: inline-block;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 300px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  top: -50%;
  left: 110%;
}

.tooltip .tooltiptext::after {
  content: "";
  position: absolute;
  top: 50%;
  right: 100%;
  margin-top: 0;
  border-width: 5px;
  border-style: solid;
  border-color: transparent black transparent transparent;
}
.tooltip:hover .tooltiptext {
  visibility: visible;
}
</style>>